import React, { useState, useEffect, useRef } from 'react';
import './compactNotification.css';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../../../shared/loader/Loader';
import { ReactComponent as BellIcon } from '../../../../assets/images/notifications/bell.svg';
import { ReactComponent as RedDot } from '../../../../assets/images/notifications/red-dot.svg';
import { routePath } from '../../../../constants/Routes';

const CompactNotification = () => {
  const { t } = useTranslation(["translation"]);
  const compactNotificationRef = useRef(null);
  const bellIconRef = useRef(null);
  const redDotIconRef = useRef(null);

  const {
    loading: notificationListLoading,
    error: notificationListErr,
    success: notificationListSuccess,
    data: notificationList
  } = useSelector((state => state.ROOTREDUCER_RTK.GetUserNotificationService));

  const [notifications, setNotifications] = useState([]);
  const [showCompactNotification, setShowCompactNotification] = useState(false);
  const [isUnReadMsgAvailable, setUnReadState] = useState(false);
  const onNotificationPage = window.location.pathname.includes('/notifications');
  useEffect(() => {
    if (notificationListSuccess) {
      const unreadNotifications = notificationList.unreadNotifications || [];
      const readNotifications = notificationList.readNotifications || [];
      const notifications = [...unreadNotifications, ...readNotifications];
      setNotifications(notifications);
      setUnReadState((notificationList.isUnreadNotificationsAvailable) ? true : false);
    }
  }, [notificationListSuccess, notificationList]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        compactNotificationRef.current &&
        !compactNotificationRef.current.contains(event.target)
        &&
        bellIconRef.current &&
        !bellIconRef.current.contains(event.target)
        &&
        redDotIconRef.current &&
        !redDotIconRef.current.contains(event.target)
      ) {
        setShowCompactNotification(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const bellIconClicked = (event) => {
    event.stopPropagation();
    setShowCompactNotification(!showCompactNotification)
  }

  return (
    <>
      {!onNotificationPage &&
        <div className="notification-wrapper" onClick={bellIconClicked}>
          <BellIcon ref={bellIconRef} />
          {isUnReadMsgAvailable && <span className="notification-dot"><RedDot ref={redDotIconRef} /></span>}
        </div>}
      {
        (showCompactNotification) &&
        <div className="compact-notification-container" ref={compactNotificationRef}>
          <h2 className="compact-notification-title">{t('BROTHER_PLUS.NOTIFICATIONS.NOTIFICATIONS')}</h2>
          {
            (notificationListLoading) && <Loader />
          }
          {
            (notificationListErr || notifications.length === 0) && <p class="info-error-message">{t('BROTHER_PLUS.NOTIFICATIONS.NO_NOTIFICATION')}</p>
          }
          {

            <ul className="compact-notification-list">
              {notificationListSuccess && notifications.slice(0, 4).map((notification) => {
                  // Truncate message body and message title
                  const truncatedMessageTitle = notification.messageTitle.substring(0, 50) +
                      (notification.messageTitle.length > 50 ? '...' : '');
                  const truncatedMessage = notification.message.substring(0, 50) + (notification.message.length > 50 ? '...' : '');
                return (
                  <li
                    key={notification.messageId}
                    className={`compact-notification-item ${notification.isRead ? 'read' : 'unread'}`}
                  >
                    <div className="compact-notification-content">
                      {!notification.isRead && <div className="unread-indicator-popup"></div>}
                      {notification.isRead && <div className="read-indicator-popup"></div>}
                      {
                          <table>
                                <tr>
                                    <span className="compact-notification-title-text">{truncatedMessageTitle} </span>
                                </tr>
                                <tr>
                                     <span className="compact-notification-message">{truncatedMessage}</span>
                                </tr>
                            </table>
                      }
                    </div>

                  </li>
                )
              })}
            </ul>
          }
          <hr className='compact-notification-divider' />
          <Link to={routePath.NOTIFICATION_CENTER} className="compact-notification-center-link">
            {t('BROTHER_PLUS.NOTIFICATIONS.NOTIFICATION_CENTER')}
          </Link>
        </div>
      }
    </>
  );
};

export default React.memo(CompactNotification);
